/*
 * Customer story watch page: the player is a facade (still + play button)
 * until the first click, then the YouTube iframe replaces both and autoplays
 * (the embed URL carries autoplay=1). Nothing from YouTube loads before that.
 */
document.querySelectorAll('[data-story-player]').forEach((player) => {
	const button = player.querySelector('button');
	if (!button || !player.dataset.storyPlayer) return;

	button.addEventListener(
		'click',
		() => {
			const iframe = document.createElement('iframe');
			iframe.src = player.dataset.storyPlayer;
			iframe.title = button.getAttribute('aria-label');
			iframe.allow =
				'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
			iframe.allowFullscreen = true;
			player.replaceChildren(iframe);
			iframe.focus();
		},
		{ once: true },
	);
});
